export default __webpack_public_path__ + "static/media/leftArrow.c845cf25.svg";